import { SET_PRESENT_MODE } from '../actionConstants';

export const setPresentModeAction = (payload) => {
  return {
    type: SET_PRESENT_MODE,
    payload,
  };
};
